import { ICON__check, ICON__plus } from '@/assets/icons_fa';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { useMemo } from 'react';

interface PROPS {
  is_positive: boolean;
  field: FIELD__list_token;
  ml_asset: DTO__ml_asset;
}

export function G_UI_FIELD__token_list_add_embedding_item({ is_positive, field, ml_asset }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const is_used = useMemo(() => get_is_used(), [is_positive, field, ml_asset, generation_current]);

  let color = is_positive ? CONSTANTS__client.TOKEN_COLOR_POSITIVE : CONSTANTS__client.TOKEN_COLOR_NEGATIVE;

  /*
   *
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    if (is_used) return;

    let field_new = field.clone();
    let field_token = field_new.create_item_new();
    field_token.type = ENUM__token_type.EMBEDDING;

    field_token.is_positive.set_value(is_positive);
    field_token.word_english.set_value(ml_asset.hash_sha256);

    field_new.field_name_and_path__fill_for_children();

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  /*
   *
   */

  function get_is_used() {
    if (generation_current._id != field.meta.graph_id) return false;

    let tokens_embeddings = field.items.filter(item => item.type == ENUM__token_type.EMBEDDING);

    return tokens_embeddings.some(item => item.word_english.get_value() == ml_asset.hash_sha256);
  }

  function get_version() {
    if (ml_asset.version == ENUM__string_id_empty.ML_ASSET_VERSION) return '';

    return `${ml_asset.version}`;
  }

  /*
   *
   */

  return (
    <div
      {...{ onClick }}
      style={{ color: color.get_value() }}
      className={`px-1 flex flex-row items-center gap-1 w-full h-5 
        rounded-sm 
        hover:bg-component-item  
        ${is_used ? 'cursor-default opacity-50' : 'cursor-pointer'}
        
        `}
    >
      {is_used ? <ICON__check className="!size-3" /> : <ICON__plus className="!size-3" />}
      <span style={{ color: color.get_value() }} className="text-xs truncate">
        {ml_asset.name} {get_version()}
      </span>
    </div>
  );
}
